//update app Type
export const UPDATE_APP_TYPE = 'UPDATE_APP_TYPE';

//set dealRoom id from the buyers link
export const SET_DEAL_ROOM_ID = 'SET_DEAL_ROOM_ID';

//set field to be displayed
export const SET_ACCESS_FIELD = 'SET_ACCESS_FIELD';

//set field data
export const SET_FIELD_DATA = 'SET_FIELD_DATA';

export const SET_DEALROOM_DATA = 'SET_DEALROOM_DATA';

export const SET_AUTHTOKEN = 'SET_AUTHTOKEN';

export const SET_SORT_ORDER = 'SET_SORT_ORDER';